export default {
    zh: {
        // 页面标题和描述
        pageTitle: 'Hailuo 2.3 视频生成器 - MiniMax AI视频创作平台',
        pageDescription:
            '体验 Hailuo 2.3 视频生成器，在复杂肢体动作、多元风格化、人物微表情以及物体运动指令响应方面实现了关键性突破，专为电商广告等商业场景优化。免费试用下一代AI视频创作工具。',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI视频生成器, 电商视频, 产品展示, 动态视频, 免费AI视频, WeryAI',

        // 生成器部分
        generatorTitle: 'Hailuo 2.3 视频生成器',
        generatorDescription:
            'WeryAI 现已深度集成Hailuo 2.3模型，在<span class="text-text-active">复杂肢体动作、多元风格化、人物微表情</span>以及<span class="text-text-active">物体运动指令响应</span>方面实现了关键性突破，尤其擅长解决电商广告等商业场景中的产品动态展示难题，显著提升视频内容的质量与产出效率。立即<span class="text-text-active">免费试用</span>，体验下一代AI视频创作的强大魅力！',

        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Hailuo 2.3 核心功能',

        // 更精准的动态控制与真实画面
        dynamicControlTitle: '更精准的动态控制与真实画面',
        dynamicControlDescription:
            '模型对物理表现与指令遵循能力显著增强，可生成更加复杂、流畅且自然的人物肢体动作。在不同的大动态运镜下，光线、明暗过渡和色调都能实现近乎实拍的视觉效果，画面稳定性和精确度更高。',

        // 更强大的多元风格化支持
        styleSupportTitle: '更强大的多元风格化支持',
        styleSupportDescription:
            '对动漫、插画、水墨、游戏CG等特殊画风的支持效果更佳。无论是通用模型还是特定风格，输出效果都更稳定、更生动，充分释放您的艺术创作潜力。',

        // 更细腻的人物微表情演绎
        microExpressionTitle: '更细腻的人物微表情演绎',
        microExpressionDescription:
            '在Hailuo 2.3中，真人面部表演和微表情变化更加自然细腻。通过AI捕捉细微的表情变化，打造更具感染力和故事性的角色表演，让角色物栩栩如生。',

        // 更出色的物体运动指令响应
        objectMotionTitle: '更出色的物体运动指令响应',
        objectMotionDescription:
            '专为电商广告场景优化，对产品的运动指令响应更加出色。可高效解决产品移动、展示等难题，有效提升电商视频广告的"抽卡"成功率和专业度。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        step1Title: '选择Hailuo 2.3模型',
        step1Description:
            '前往<span class="highlight-text">"AI视频生成"</span>页面，然后在模型下拉菜单中点击"Hailuo 2.3"。',
        step2Title: '输入您的创意内容',
        step2Description:
            '描述您想要生成的内容，或上传图片进行转换，并选择您喜欢的风格和效果。',
        step3Title: '下载您的视频',
        step3Description: '点击"创建"，即可随意下载或分享生成的优化视频。',

        // YouTube 视频部分
        youtubeTitle: 'Hailuo 2.3 视频模型相关 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Hailuo 2.3 视频模型的 X 推文',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他视频模型',
        hailuo02Title: 'Hailuo 02 AI视频生成器',
        sora2Title: 'OpenAI Sora-2 AI视频生成器',
        wanTitle: 'Wan AI视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',







        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Hailuo 2.3，将您的创意转化为精彩视频',
        ctaButton: '在 WeryAI 上试用 Hailuo 2.3',

        ctaDisclaimer: '无需信用卡',


        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoLoadError: '视频加载失败',
        videoReload: '重新加载',
    },
    en: {
        // Page title and description
        pageTitle:
            'Hailuo 2.3 Video Generator - MiniMax AI Video Creation Platform',
        pageDescription:
            'Experience Hailuo 2.3 video generator with breakthrough achievements in complex body movements, diverse stylization, facial micro-expressions, and object motion command response. Optimized for e-commerce advertising scenarios. Try the next-generation AI video creation tool for free.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI video generator, e-commerce video, product showcase, dynamic video, free AI video, WeryAI',

        // Generator section
        generatorTitle: 'Hailuo 2.3 Video Generator',
        generatorDescription:
            'WeryAI now deeply integrates the Hailuo 2.3 model, achieving key breakthroughs in <span class="text-text-active">complex body movements, diverse stylization, facial micro-expressions</span>, and <span class="text-text-active">object motion command response</span>. It excels at solving dynamic product display challenges in commercial scenarios such as e-commerce advertising, significantly improving video content quality and production efficiency. <span class="text-text-active">Try it free now</span> and experience the powerful charm of next-generation AI video creation!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo 2.3 Core Features',

        // More precise dynamic control and realistic visuals
        dynamicControlTitle:
            'More Precise Dynamic Control and Realistic Visuals',
        dynamicControlDescription:
            "The model's physical performance and instruction-following capabilities are significantly enhanced, generating more complex, smooth, and natural character body movements. Under different large dynamic camera movements, lighting, brightness transitions, and color tones can achieve near-real visual effects with higher stability and accuracy.",

        // Stronger diverse stylization support
        styleSupportTitle: 'Stronger Diverse Stylization Support',
        styleSupportDescription:
            'Better support for special art styles such as anime, illustration, ink painting, and game CG. Whether using general models or specific styles, output results are more stable and vivid, fully unleashing your artistic creative potential.',

        // More delicate facial micro-expression performance
        microExpressionTitle:
            'More Delicate Facial Micro-Expression Performance',
        microExpressionDescription:
            'In Hailuo 2.3, real-person facial performances and micro-expression changes are more natural and delicate. By capturing subtle expression changes through AI, it creates more infectious and story-driven character performances, making digital characters come to life.',

        // Superior object motion command response
        objectMotionTitle: 'Superior Object Motion Command Response',
        objectMotionDescription:
            'Optimized specifically for e-commerce advertising scenarios, with excellent response to product motion commands. It efficiently solves challenges in product movement and display, effectively improving the "draw rate" success and professionalism of e-commerce video advertising.',

        // How to use section
        howToUseTitle: 'How to Use',
        step1Title: 'Select Hailuo 2.3 Model',
        step1Description:
            'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo 2.3" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description:
            'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description:
            'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 2.3 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 2.3 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models',
        hailuo02Title: 'Hailuo 02 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        wanTitle: 'Wan AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',







        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription:
            'Experience Hailuo 2.3 now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo 2.3 on WeryAI',
        ctaDisclaimer: 'No credit card required',

        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
    },
    ja: {
        // ページタイトルと説明
        pageTitle:
            'Hailuo 2.3 動画ジェネレーター - MiniMax AI動画作成プラットフォーム',
        pageDescription:
            'Hailuo 2.3 動画ジェネレーターを体験。複雑な身体の動き、多様なスタイル化、顔の微表情、物体の動作指令への応答において画期的な成果を実現。Eコマース広告シナリオに最適化。次世代AI動画作成ツールを無料で試す。',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI動画ジェネレーター, Eコマース動画, 製品ショーケース, ダイナミック動画, 無料AI動画, WeryAI',

        // ジェネレーター部分
        generatorTitle: 'Hailuo 2.3 動画ジェネレーター',
        generatorDescription:
            'WeryAI はHailuo 2.3モデルを深く統合し、Eコマース広告などの商業シナリオにおける製品の動的表示の課題を解決することに優れ、動画コンテンツの品質と生産効率を大幅に向上させます。<span class="text-text-active">今すぐ無料で試して</span>、次世代AI動画作成の強力な魅力を体験してください！',

        // タブ
        tabImageToVideo: '画像から動画',
        tabTextToVideo: 'テキストから動画',

        // コア機能部分
        coreFeaturesTitle: 'Hailuo 2.3 コア機能',

        // より精密な動的制御と現実的なビジュアル
        dynamicControlTitle: 'より精密な動的制御と現実的なビジュアル',
        dynamicControlDescription:
            'モデルの物理的パフォーマンスと指示に従う能力が大幅に強化され、より複雑で滑らかで自然なキャラクターの身体の動きを生成します。さまざまな大きな動的カメラの動きの下で、照明、明暗の遷移、色調が実写に近い視覚効果を実現し、より高い安定性と精度を実現します。',

        // より強力な多様なスタイル化サポート
        styleSupportTitle: 'より強力な多様なスタイル化サポート',
        styleSupportDescription:
            'アニメ、イラスト、水墨画、ゲームCGなどの特別なアートスタイルのサポートが向上。汎用モデルまたは特定のスタイルを使用する場合でも、出力結果はより安定して生き生きとし、芸術的な創造性を最大限に発揮します。',

        // より繊細な顔の微表情パフォーマンス
        microExpressionTitle: 'より繊細な顔の微表情パフォーマンス',
        microExpressionDescription:
            'Hailuo 2.3では、実在の人物の顔のパフォーマンスと微表情の変化がより自然で繊細になります。AIを通じて微妙な表情の変化を捉えることで、より感染力のあるストーリー性のあるキャラクターのパフォーマンスを作成し、デジタルキャラクターを生き生きとさせます。',

        // 優れた物体の動作指令への応答
        objectMotionTitle: '優れた物体の動作指令への応答',
        objectMotionDescription:
            'Eコマース広告シナリオに特化して最適化され、製品の動作指令への優れた応答を実現。製品の移動と表示の課題を効率的に解決し、Eコマース動画広告の「ドロー率」の成功とプロフェッショナリズムを効果的に向上させます。',

        // 使用方法部分
        howToUseTitle: '使用方法',
        step1Title: 'Hailuo 2.3モデルを選択',
        step1Description:
            '<span class="highlight-text">「AI動画生成」</span>ページに移動し、モデルドロップダウンメニューで「Hailuo 2.3」をクリックします。',
        step2Title: '創造的なコンテンツを入力',
        step2Description:
            '生成したい内容を記述するか、変換用の画像をアップロードし、好きなスタイルと効果を選択します。',
        step3Title: '動画をダウンロード',
        step3Description:
            '「作成」をクリックして、生成された最適化された動画を自由にダウンロードまたは共有します。',

        // YouTube動画部分
        youtubeTitle: 'Hailuo 2.3 ビデオモデル関連のYouTube動画',

        // X投稿部分
        xPostsTitle: 'Hailuo 2.3 ビデオモデルに関する人気のX投稿',

        // 他のモデル探索部分
        exploreModelsTitle: '他のビデオモデルを探索',
        hailuo02Title: 'Hailuo 02 AI動画ジェネレーター',
        sora2Title: 'OpenAI Sora-2 AI動画ジェネレーター',
        wanTitle: 'Wan AI動画ジェネレーター',

        // FAQ部分
        faqTitle: 'よくある質問',







        // CTA部分
        ctaTitle: '作成を始める準備はできましたか？',
        ctaDescription:
            '今すぐHailuo 2.3を体験し、あなたの創造性を素晴らしい動画に変換',
        ctaButton: 'WeryAIでHailuo 2.3を試す',
        ctaDisclaimer: 'クレジットカード不要',

        // 動画再生関連
        videoNotSupported: 'お使いのブラウザは動画再生をサポートしていません',
        videoLoadError: '動画の読み込みに失敗しました',
        videoReload: '再読み込み',
    },
    ko: {
        // 페이지 제목과 설명
        pageTitle: 'Hailuo 2.3 비디오 생성기 - MiniMax AI 비디오 제작 플랫폼',
        pageDescription:
            'Hailuo 2.3 비디오 생성기를 체험하세요. 복잡한 신체 움직임, 다양한 스타일화, 얼굴 미세 표정, 물체 동작 명령 응답에서 획기적인 성과를 달성. 전자상거래 광고 시나리오에 최적화. 차세대 AI 비디오 제작 도구를 무료로 체험하세요.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI 비디오 생성기, 전자상거래 비디오, 제품 쇼케이스, 동적 비디오, 무료 AI 비디오, WeryAI',

        // 생성기 부분
        generatorTitle: 'Hailuo 2.3 비디오 생성기',
        generatorDescription:
            'WeryAI는 이제 Hailuo 2.3 모델을 심층 통합하여, <span class="text-text-active">복잡한 신체 움직임, 다양한 스타일화, 얼굴 미세 표정</span> 및 <span class="text-text-active">물체 동작 명령 응답</span>에서 중요한 돌파구를 달성했습니다. 전자상거래 광고와 같은 상업적 시나리오에서 제품의 동적 표시 문제를 해결하는 데 탁월하며, 비디오 콘텐츠 품질과 생산 효율성을 크게 향상시킵니다. <span class="text-text-active">지금 무료로 체험하고</span> 차세대 AI 비디오 제작의 강력한 매력을 경험하세요!',

        // 탭
        tabImageToVideo: '이미지에서 비디오',
        tabTextToVideo: '텍스트에서 비디오',

        // 핵심 기능 부분
        coreFeaturesTitle: 'Hailuo 2.3 핵심 기능',

        // 더 정밀한 동적 제어와 현실적인 비주얼
        dynamicControlTitle: '더 정밀한 동적 제어와 현실적인 비주얼',
        dynamicControlDescription:
            '모델의 물리적 성능과 지시 따르기 능력이 크게 향상되어 더 복잡하고 부드럽고 자연스러운 캐릭터 신체 움직임을 생성합니다. 다양한 대형 동적 카메라 움직임 아래에서 조명, 밝기 전환 및 색조가 실제에 가까운 시각 효과를 달성하여 더 높은 안정성과 정확성을 실현합니다.',

        // 더 강력한 다양한 스타일화 지원
        styleSupportTitle: '더 강력한 다양한 스타일화 지원',
        styleSupportDescription:
            '애니메이션, 일러스트레이션, 수묵화, 게임 CG 등의 특별한 아트 스타일에 대한 지원이 향상되었습니다. 범용 모델 또는 특정 스타일을 사용하든 출력 결과가 더 안정적이고 생동감 있으며, 예술적 창의성을 최대한 발휘합니다.',

        // 더 섬세한 얼굴 미세 표정 연기
        microExpressionTitle: '더 섬세한 얼굴 미세 표정 연기',
        microExpressionDescription:
            'Hailuo 2.3에서는 실제 사람의 얼굴 연기와 미세 표정 변화가 더 자연스럽고 섬세합니다. AI를 통해 미묘한 표정 변화를 포착하여 더 감염력 있고 스토리성 있는 캐릭터 연기를 만들어 디지털 캐릭터를 생생하게 만듭니다.',

        // 우수한 물체 동작 명령 응답
        objectMotionTitle: '우수한 물체 동작 명령 응답',
        objectMotionDescription:
            '전자상거래 광고 시나리오에 특화되어 최적화되었으며, 제품의 동작 명령에 대한 우수한 응답을 실현합니다. 제품 이동 및 표시 문제를 효율적으로 해결하고, 전자상거래 비디오 광고의 "추첨율" 성공과 전문성을 효과적으로 향상시킵니다.',

        // 사용 방법 부분
        howToUseTitle: '사용 방법',
        step1Title: 'Hailuo 2.3 모델 선택',
        step1Description:
            '<span class="highlight-text">「AI 비디오 생성」</span> 페이지로 이동한 다음 모델 드롭다운 메뉴에서 「Hailuo 2.3」을 클릭합니다.',
        step2Title: '창의적인 콘텐츠 입력',
        step2Description:
            '생성하려는 내용을 설명하거나 변환용 이미지를 업로드하고 선호하는 스타일과 효과를 선택합니다.',
        step3Title: '비디오 다운로드',
        step3Description:
            '「생성」을 클릭하여 생성된 최적화된 비디오를 자유롭게 다운로드하거나 공유합니다.',

        // YouTube 비디오 부분
        youtubeTitle: 'Hailuo 2.3 비디오 모델 관련 YouTube 비디오',

        // X 게시물 부분
        xPostsTitle: 'Hailuo 2.3 비디오 모델에 관한 인기 X 게시물',

        // 다른 모델 탐색 부분
        exploreModelsTitle: '다른 비디오 모델 탐색',
        hailuo02Title: 'Hailuo 02 AI 비디오 생성기',
        sora2Title: 'OpenAI Sora-2 AI 비디오 생성기',
        wanTitle: 'Wan AI 비디오 생성기',

        // FAQ 부분
        faqTitle: '자주 묻는 질문',







        // CTA 부분
        ctaTitle: '제작을 시작할 준비가 되셨나요?',
        ctaDescription:
            '지금 Hailuo 2.3을 체험하고 당신의 창의성을 놀라운 비디오로 변환하세요',
        ctaButton: 'WeryAI에서 Hailuo 2.3 체험하기',
        ctaDisclaimer: '신용카드 불필요',

        // 비디오 재생 관련
        videoNotSupported: '귀하의 브라우저는 비디오 재생을 지원하지 않습니다',
        videoLoadError: '비디오 로딩 실패',
        videoReload: '다시 로드',
    },
    tw: {

        // 页面标题和描述
        pageTitle: 'Hailuo 2.3 视频生成器 - MiniMax AI视频创作平台',
        pageDescription:
            '体验 Hailuo 2.3 视频生成器，在复杂肢体动作、多元风格化、人物微表情以及物体运动指令响应方面实现了关键性突破，专为电商广告等商业场景优化。免费试用下一代AI视频创作工具。',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI视频生成器, 电商视频, 产品展示, 动态视频, 免费AI视频, WeryAI',

        // 生成器部分
        generatorTitle: 'Hailuo 2.3 视频生成器',
        generatorDescription:
            'WeryAI 現已深度整合Hailuo 2.3模型，在<span class="text-text-active">复杂肢体动作、多元风格化、人物微表情</span>以及<span class="text-text-active">物体运动指令响应</span>方面实现了关键性突破，尤其擅长解决电商广告等商业场景中的产品动态展示难题，显著提升视频内容的质量与产出效率。立即<span class="text-text-active">免费试用</span>，体验下一代AI视频创作的强大魅力！',

        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Hailuo 2.3 核心功能',

        // 更精准的动态控制与真实画面
        dynamicControlTitle: '更精准的动态控制与真实画面',
        dynamicControlDescription:
            '模型对物理表现与指令遵循能力显著增强，可生成更加复杂、流畅且自然的人物肢体动作。在不同的大动态运镜下，光线、明暗过渡和色调都能实现近乎实拍的视觉效果，画面稳定性和精确度更高。',

        // 更强大的多元风格化支持
        styleSupportTitle: '更强大的多元风格化支持',
        styleSupportDescription:
            '对动漫、插画、水墨、游戏CG等特殊画风的支持效果更佳。无论是通用模型还是特定风格，输出效果都更稳定、更生动，充分释放您的艺术创作潜力。',

        // 更细腻的人物微表情演绎
        microExpressionTitle: '更细腻的人物微表情演绎',
        microExpressionDescription:
            '在Hailuo 2.3中，真人面部表演和微表情变化更加自然细腻。通过AI捕捉细微的表情变化，打造更具感染力和故事性的角色表演，让角色物栩栩如生。',

        // 更出色的物体运动指令响应
        objectMotionTitle: '更出色的物体运动指令响应',
        objectMotionDescription:
            '专为电商广告场景优化，对产品的运动指令响应更加出色。可高效解决产品移动、展示等难题，有效提升电商视频广告的"抽卡"成功率和专业度。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        step1Title: '选择Hailuo 2.3模型',
        step1Description:
            '前往<span class="highlight-text">"AI视频生成"</span>页面，然后在模型下拉菜单中点击"Hailuo 2.3"。',
        step2Title: '输入您的创意内容',
        step2Description:
            '描述您想要生成的内容，或上传图片进行转换，并选择您喜欢的风格和效果。',
        step3Title: '下载您的视频',
        step3Description: '点击"创建"，即可随意下载或分享生成的优化视频。',

        // YouTube 视频部分
        youtubeTitle: 'Hailuo 2.3 视频模型相关 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Hailuo 2.3 视频模型的 X 推文',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他视频模型',
        hailuo02Title: 'Hailuo 02 AI视频生成器',
        sora2Title: 'OpenAI Sora-2 AI视频生成器',
        wanTitle: 'Wan AI视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',







        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Hailuo 2.3，将您的创意转化为精彩视频',
        ctaButton: '在 WeryAI 上试用 Hailuo 2.3',

        ctaDisclaimer: '无需信用卡',


        // 视频播放相关
        videoNotSupported: '您的浏览器不支持视频播放',
        videoLoadError: '视频加载失败',
        videoReload: '重新加载',
    },
    pl: {

        // Page title and description
        pageTitle:
            'Hailuo 2.3 Video Generator - MiniMax AI Video Creation Platform',
        pageDescription:
            'Experience Hailuo 2.3 video generator with breakthrough achievements in complex body movements, diverse stylization, facial micro-expressions, and object motion command response. Optimized for e-commerce advertising scenarios. Try the next-generation AI video creation tool for free.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI video generator, e-commerce video, product showcase, dynamic video, free AI video, WeryAI',

        // Generator section
        generatorTitle: 'Hailuo 2.3 Video Generator',
        generatorDescription:
            'WeryAI jest teraz głęboko zintegrowane z modelem Hailuo 2.3, achieving key breakthroughs in <span class="text-text-active">complex body movements, diverse stylization, facial micro-expressions</span>, and <span class="text-text-active">object motion command response</span>. It excels at solving dynamic product display challenges in commercial scenarios such as e-commerce advertising, significantly improving video content quality and production efficiency. <span class="text-text-active">Try it free now</span> and experience the powerful charm of next-generation AI video creation!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo 2.3 Core Features',

        // More precise dynamic control and realistic visuals
        dynamicControlTitle:
            'More Precise Dynamic Control and Realistic Visuals',
        dynamicControlDescription:
            "The model's physical performance and instruction-following capabilities are significantly enhanced, generating more complex, smooth, and natural character body movements. Under different large dynamic camera movements, lighting, brightness transitions, and color tones can achieve near-real visual effects with higher stability and accuracy.",

        // Stronger diverse stylization support
        styleSupportTitle: 'Stronger Diverse Stylization Support',
        styleSupportDescription:
            'Better support for special art styles such as anime, illustration, ink painting, and game CG. Whether using general models or specific styles, output results are more stable and vivid, fully unleashing your artistic creative potential.',

        // More delicate facial micro-expression performance
        microExpressionTitle:
            'More Delicate Facial Micro-Expression Performance',
        microExpressionDescription:
            'In Hailuo 2.3, real-person facial performances and micro-expression changes are more natural and delicate. By capturing subtle expression changes through AI, it creates more infectious and story-driven character performances, making digital characters come to life.',

        // Superior object motion command response
        objectMotionTitle: 'Superior Object Motion Command Response',
        objectMotionDescription:
            'Optimized specifically for e-commerce advertising scenarios, with excellent response to product motion commands. It efficiently solves challenges in product movement and display, effectively improving the "draw rate" success and professionalism of e-commerce video advertising.',

        // How to use section
        howToUseTitle: 'Jak używać',
        step1Title: 'Select Hailuo 2.3 Model',
        step1Description:
            'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo 2.3" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description:
            'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description:
            'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 2.3 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 2.3 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models',
        hailuo02Title: 'Hailuo 02 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        wanTitle: 'Wan AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',







        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription:
            'Experience Hailuo 2.3 now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo 2.3 on WeryAI',

        ctaDisclaimer: 'No credit card required',


        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
    },
    es: {
        // Título y descripción de la página
        pageTitle:
            'Generador de Video Hailuo 2.3 - Plataforma de Creación de Video IA MiniMax',
        pageDescription:
            'Experimenta el generador de video Hailuo 2.3 con avances revolucionarios en movimientos corporales complejos, estilización diversa, microexpresiones faciales y respuesta a comandos de movimiento de objetos. Optimizado para escenarios de publicidad de comercio electrónico. Prueba gratis la herramienta de creación de video IA de próxima generación.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, generador de video IA, video de comercio electrónico, exhibición de productos, video dinámico, video IA gratis, WeryAI',

        // Sección del generador
        generatorTitle: 'Generador de Video Hailuo 2.3',
        generatorDescription:
            'WeryAI ahora integra profundamente el modelo Hailuo 2.3, logrando avances clave en <span class="text-text-active">movimientos corporales complejos, estilización diversa, microexpresiones faciales</span> y <span class="text-text-active">respuesta a comandos de movimiento de objetos</span>. Sobresale en resolver desafíos de exhibición dinámica de productos en escenarios comerciales como la publicidad de comercio electrónico, mejorando significativamente la calidad del contenido de video y la eficiencia de producción. <span class="text-text-active">Pruébalo gratis ahora</span> y experimenta el poderoso encanto de la creación de video IA de próxima generación!',

        // Pestañas
        tabImageToVideo: 'Imagen a Video',
        tabTextToVideo: 'Texto a Video',

        // Sección de características principales
        coreFeaturesTitle: 'Características Principales de Hailuo 2.3',

        // Control dinámico más preciso y visuales realistas
        dynamicControlTitle:
            'Control Dinámico Más Preciso y Visuales Realistas',
        dynamicControlDescription:
            'El rendimiento físico del modelo y las capacidades de seguimiento de instrucciones están significativamente mejoradas, generando movimientos corporales de personajes más complejos, suaves y naturales. Bajo diferentes movimientos de cámara dinámicos grandes, la iluminación, las transiciones de brillo y los tonos de color pueden lograr efectos visuales casi reales con mayor estabilidad y precisión.',

        // Soporte de estilización diversa más fuerte
        styleSupportTitle: 'Soporte de Estilización Diversa Más Fuerte',
        styleSupportDescription:
            'Mejor soporte para estilos de arte especiales como anime, ilustración, pintura de tinta y CG de videojuegos. Ya sea usando modelos generales o estilos específicos, los resultados de salida son más estables y vívidos, liberando completamente tu potencial creativo artístico.',

        // Interpretación de microexpresiones faciales más delicada
        microExpressionTitle:
            'Interpretación de Microexpresiones Faciales Más Delicada',
        microExpressionDescription:
            'En Hailuo 2.3, las interpretaciones faciales de personas reales y los cambios de microexpresiones son más naturales y delicados. Al capturar cambios sutiles de expresión a través de IA, crea interpretaciones de personajes más infecciosas e impulsadas por historias, haciendo que los personajes digitales cobren vida.',

        // Respuesta superior a comandos de movimiento de objetos
        objectMotionTitle:
            'Respuesta Superior a Comandos de Movimiento de Objetos',
        objectMotionDescription:
            'Optimizado específicamente para escenarios de publicidad de comercio electrónico, con excelente respuesta a comandos de movimiento de productos. Resuelve eficientemente desafíos en el movimiento y exhibición de productos, mejorando efectivamente la tasa de éxito y el profesionalismo de la publicidad de video de comercio electrónico.',

        // Sección de cómo usar
        howToUseTitle: 'Cómo Usar',
        step1Title: 'Seleccionar Modelo Hailuo 2.3',
        step1Description:
            'Ve a la página de <span class="highlight-text">"Generación de Video IA"</span>, luego haz clic en "Hailuo 2.3" en el menú desplegable de modelos.',
        step2Title: 'Ingresa Tu Contenido Creativo',
        step2Description:
            'Describe lo que deseas generar, o carga imágenes para conversión, y elige tus estilos y efectos preferidos.',
        step3Title: 'Descarga Tu Video',
        step3Description:
            'Haz clic en "Crear" para descargar o compartir el video optimizado generado.',

        // Sección de videos de YouTube
        youtubeTitle: 'Videos de YouTube sobre el Modelo de Video Hailuo 2.3',

        // Sección de publicaciones de X
        xPostsTitle:
            'Publicaciones Populares de X sobre el Modelo de Video Hailuo 2.3',

        // Sección de explorar otros modelos
        exploreModelsTitle: 'Explorar Otros Modelos',
        hailuo02Title: 'Generador de Video IA Hailuo 02',
        sora2Title: 'Generador de Video IA OpenAI Sora-2',
        wanTitle: 'Generador de Video IA Wan',

        // Sección de preguntas frecuentes
        faqTitle: 'Preguntas Frecuentes',







        // Sección CTA
        ctaTitle: '¿Listo para Comenzar a Crear?',
        ctaDescription:
            'Experimenta Hailuo 2.3 ahora y transforma tu creatividad en videos increíbles',
        ctaButton: 'Prueba Hailuo 2.3 en WeryAI',
        ctaDisclaimer: 'No se requiere tarjeta de crédito',

        // Relacionado con reproducción de video
        videoNotSupported: 'Tu navegador no admite la reproducción de video',
        videoLoadError: 'Error al cargar el video',
        videoReload: 'Recargar',
    },
    fr: {
        // Titre et description de la page
        pageTitle:
            'Générateur Vidéo Hailuo 2.3 - Plateforme de Création Vidéo IA MiniMax',
        pageDescription:
            "Découvrez le générateur vidéo Hailuo 2.3 avec des avancées révolutionnaires dans les mouvements corporels complexes, la stylisation diverse, les micro-expressions faciales et la réponse aux commandes de mouvement d'objets. Optimisé pour les scénarios publicitaires de commerce électronique. Essayez gratuitement l'outil de création vidéo IA de nouvelle génération.",
        pageKeywords:
            'Hailuo 2.3, MiniMax, générateur vidéo IA, vidéo e-commerce, vitrine de produits, vidéo dynamique, vidéo IA gratuite, WeryAI',

        // Section générateur
        generatorTitle: 'Générateur Vidéo Hailuo 2.3',
        generatorDescription:
            'WeryAI intègre désormais en profondeur le modèle Hailuo 2.3, réalisant des percées clés dans <span class="text-text-active">les mouvements corporels complexes, la stylisation diverse, les micro-expressions faciales</span> et <span class="text-text-active">la réponse aux commandes de mouvement d\'objets</span>. Il excelle à résoudre les défis d\'affichage dynamique de produits dans des scénarios commerciaux tels que la publicité de commerce électronique, améliorant considérablement la qualité du contenu vidéo et l\'efficacité de production. <span class="text-text-active">Essayez-le gratuitement maintenant</span> et découvrez le charme puissant de la création vidéo IA de nouvelle génération!',

        // Onglets
        tabImageToVideo: 'Image vers Vidéo',
        tabTextToVideo: 'Texte vers Vidéo',

        // Section des fonctionnalités principales
        coreFeaturesTitle: 'Fonctionnalités Principales de Hailuo 2.3',

        dynamicControlTitle:
            'Contrôle Dynamique Plus Précis et Visuels Réalistes',
        dynamicControlDescription:
            "Les performances physiques du modèle et les capacités de suivi des instructions sont considérablement améliorées, générant des mouvements corporels de personnages plus complexes, fluides et naturels. Sous différents grands mouvements de caméra dynamiques, l'éclairage, les transitions de luminosité et les tons de couleur peuvent obtenir des effets visuels presque réels avec une plus grande stabilité et précision.",

        styleSupportTitle: 'Support de Stylisation Diverse Plus Fort',
        styleSupportDescription:
            "Meilleur support pour les styles artistiques spéciaux tels que l'anime, l'illustration, la peinture à l'encre et le CG de jeux vidéo. Que vous utilisiez des modèles généraux ou des styles spécifiques, les résultats de sortie sont plus stables et vivants, libérant complètement votre potentiel créatif artistique.",

        microExpressionTitle:
            'Interprétation de Micro-expressions Faciales Plus Délicate',
        microExpressionDescription:
            "Dans Hailuo 2.3, les performances faciales de personnes réelles et les changements de micro-expressions sont plus naturels et délicats. En capturant les changements d'expression subtils grâce à l'IA, il crée des performances de personnages plus contagieuses et axées sur l'histoire, donnant vie aux personnages numériques.",

        objectMotionTitle:
            "Réponse Supérieure aux Commandes de Mouvement d'Objets",
        objectMotionDescription:
            "Optimisé spécifiquement pour les scénarios publicitaires de commerce électronique, avec une excellente réponse aux commandes de mouvement de produits. Il résout efficacement les défis du mouvement et de l'affichage des produits, améliorant efficacement le taux de réussite et le professionnalisme de la publicité vidéo de commerce électronique.",

        howToUseTitle: 'Comment Utiliser',
        step1Title: 'Sélectionner le Modèle Hailuo 2.3',
        step1Description:
            'Accédez à la page <span class="highlight-text">"Génération de Vidéo IA"</span>, puis cliquez sur "Hailuo 2.3" dans le menu déroulant des modèles.',
        step2Title: 'Saisissez Votre Contenu Créatif',
        step2Description:
            'Décrivez ce que vous souhaitez générer, ou téléchargez des images pour conversion, et choisissez vos styles et effets préférés.',
        step3Title: 'Téléchargez Votre Vidéo',
        step3Description:
            'Cliquez sur "Créer" pour télécharger ou partager la vidéo optimisée générée.',

        youtubeTitle: 'Vidéos YouTube sur le Modèle Vidéo Hailuo 2.3',
        xPostsTitle: 'Publications X Populaires sur le Modèle Vidéo Hailuo 2.3',

        exploreModelsTitle: "Explorer D'autres Modèles",
        hailuo02Title: 'Générateur Vidéo IA Hailuo 02',
        sora2Title: 'Générateur Vidéo IA OpenAI Sora-2',
        wanTitle: 'Générateur Vidéo IA Wan',

        faqTitle: 'Questions Fréquemment Posées',







        ctaTitle: 'Prêt à Commencer à Créer?',
        ctaDescription:
            'Découvrez Hailuo 2.3 maintenant et transformez votre créativité en vidéos incroyables',
        ctaButton: 'Essayez Hailuo 2.3 sur WeryAI',
        ctaDisclaimer: 'Aucune carte de crédit requise',

        videoNotSupported:
            'Votre navigateur ne prend pas en charge la lecture vidéo',
        videoLoadError: 'Échec du chargement de la vidéo',
        videoReload: 'Recharger',
    },
    de: {
        pageTitle:
            'Hailuo 2.3 Video Generator - MiniMax KI-Video-Erstellungsplattform',
        pageDescription:
            'Erleben Sie den Hailuo 2.3 Video Generator mit revolutionären Durchbrüchen bei komplexen Körperbewegungen, vielfältiger Stilisierung, Gesichtsmikroausdrücken und Objektbewegungsbefehlsantwort.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, KI-Video-Generator, E-Commerce-Video, Produktpräsentation, dynamisches Video, kostenloses KI-Video, WeryAI',

        generatorTitle: 'Hailuo 2.3 Video Generator',
        generatorDescription:
            'WeryAI integriert jetzt das Modell Hailuo 2.3 tiefgreifend, vielfältiger Stilisierung, Gesichtsmikroausdrücken</span> und <span class="text-text-active">Objektbewegungsbefehlsantwort</span>.',

        tabImageToVideo: 'Bild zu Video',
        tabTextToVideo: 'Text zu Video',

        coreFeaturesTitle: 'Hailuo 2.3 Hauptfunktionen',
        dynamicControlTitle:
            'Präzisere Dynamische Steuerung und Realistische Visuals',
        dynamicControlDescription:
            'Die physikalische Leistung und die Anweisungsbefolgungsfähigkeiten des Modells sind erheblich verbessert.',
        styleSupportTitle: 'Stärkere Diverse Stilisierungsunterstützung',
        styleSupportDescription:
            'Bessere Unterstützung für spezielle Kunststile wie Anime, Illustration, Tuschemalerei und Videospiel-CG.',
        microExpressionTitle: 'Feinere Gesichtsmikroausdrucks-Interpretation',
        microExpressionDescription:
            'In Hailuo 2.3 sind echte Gesichtsdarstellungen und Mikroausdrucksänderungen natürlicher und feiner.',
        objectMotionTitle: 'Überlegene Objektbewegungsbefehlsantwort',
        objectMotionDescription:
            'Speziell für E-Commerce-Werbeszenarien optimiert, mit hervorragender Antwort auf Produktbewegungsbefehle.',

        howToUseTitle: 'Wie zu Verwenden',
        step1Title: 'Hailuo 2.3 Modell Auswählen',
        step1Description:
            'Gehen Sie zur Seite <span class="highlight-text">"KI-Videogenerierung"</span> und klicken Sie dann im Modell-Dropdown-Menü auf "Hailuo 2.3".',
        step2Title: 'Geben Sie Ihren Kreativen Inhalt Ein',
        step2Description:
            'Beschreiben Sie, was Sie generieren möchten, oder laden Sie Bilder zur Konvertierung hoch.',
        step3Title: 'Laden Sie Ihr Video Herunter',
        step3Description:
            'Klicken Sie auf "Erstellen", um das generierte optimierte Video herunterzuladen oder zu teilen.',

        youtubeTitle: 'YouTube-Videos über das Hailuo 2.3 Videomodell',
        xPostsTitle: 'Beliebte X-Beiträge über das Hailuo 2.3 Videomodell',

        exploreModelsTitle: 'Andere Modelle Erkunden',
        hailuo02Title: 'Hailuo 02 KI-Video-Generator',
        sora2Title: 'OpenAI Sora-2 KI-Video-Generator',
        wanTitle: 'Wan KI-Video-Generator',

        faqTitle: 'Häufig Gestellte Fragen',

        ctaTitle: 'Bereit zum Erstellen?',
        ctaDescription:
            'Erleben Sie Hailuo 2.3 jetzt und verwandeln Sie Ihre Kreativität in erstaunliche Videos',
        ctaButton: 'Probieren Sie Hailuo 2.3 auf WeryAI',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich',

        videoNotSupported: 'Ihr Browser unterstützt die Videowiedergabe nicht',
        videoLoadError: 'Video konnte nicht geladen werden',
        videoReload: 'Neu laden',
    },
    ru: {
        pageTitle:
            'Генератор Видео Hailuo 2.3 - Платформа Создания ИИ-Видео MiniMax',
        pageDescription:
            'Испытайте генератор видео Hailuo 2.3 с революционными достижениями в сложных движениях тела, разнообразной стилизации, микровыражениях лица и ответе на команды движения объектов.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, генератор ИИ-видео, видео электронной коммерции, демонстрация продукта, динамическое видео, бесплатное ИИ-видео, WeryAI',

        generatorTitle: 'Генератор Видео Hailuo 2.3',
        generatorDescription:
            'WeryAI теперь глубоко интегрировал модель Hailuo 2.3, достигающее ключевых прорывов в <span class="text-text-active">сложных движениях тела, разнообразной стилизации, микровыражениях лица</span> и <span class="text-text-active">ответе на команды движения объектов</span>.',

        tabImageToVideo: 'Изображение в Видео',
        tabTextToVideo: 'Текст в Видео',

        coreFeaturesTitle: 'Основные Функции Hailuo 2.3',
        dynamicControlTitle:
            'Более Точный Динамический Контроль и Реалистичные Визуализации',
        dynamicControlDescription:
            'Физические характеристики модели и возможности следования инструкциям значительно улучшены.',
        styleSupportTitle: 'Более Сильная Поддержка Разнообразной Стилизации',
        styleSupportDescription:
            'Лучшая поддержка специальных художественных стилей, таких как аниме, иллюстрация, чернильная живопись и игровой CG.',
        microExpressionTitle: 'Более Тонкая Интерпретация Микровыражений Лица',
        microExpressionDescription:
            'В Hailuo 2.3 выступления реальных лиц и изменения микровыражений более естественны и тонки.',
        objectMotionTitle: 'Превосходный Ответ на Команды Движения Объектов',
        objectMotionDescription:
            'Специально оптимизирован для сценариев рекламы электронной коммерции.',

        howToUseTitle: 'Как Использовать',
        step1Title: 'Выберите Модель Hailuo 2.3',
        step1Description:
            'Перейдите на страницу <span class="highlight-text">"Генерация ИИ-Видео"</span>, затем нажмите "Hailuo 2.3" в выпадающем меню моделей.',
        step2Title: 'Введите Ваш Творческий Контент',
        step2Description:
            'Опишите, что вы хотите сгенерировать, или загрузите изображения для преобразования.',
        step3Title: 'Скачайте Ваше Видео',
        step3Description:
            'Нажмите "Создать", чтобы загрузить или поделиться сгенерированным оптимизированным видео.',

        youtubeTitle: 'Видео YouTube о Видеомодели Hailuo 2.3',
        xPostsTitle: 'Популярные Публикации X о Видеомодели Hailuo 2.3',

        exploreModelsTitle: 'Исследовать Другие Модели',
        hailuo02Title: 'Генератор ИИ-Видео Hailuo 02',
        sora2Title: 'Генератор ИИ-Видео OpenAI Sora-2',
        wanTitle: 'Генератор ИИ-Видео Wan',

        faqTitle: 'Часто Задаваемые Вопросы',

        ctaTitle: 'Готовы Начать Создавать?',
        ctaDescription:
            'Испытайте Hailuo 2.3 сейчас и превратите свое творчество в удивительные видео',
        ctaButton: 'Попробуйте Hailuo 2.3 на WeryAI',
        ctaDisclaimer: 'Кредитная карта не требуется',

        videoNotSupported: 'Ваш браузер не поддерживает воспроизведение видео',
        videoLoadError: 'Ошибка загрузки видео',
        videoReload: 'Перезагрузить',
    },
    pt: {
        pageTitle:
            'Gerador de Vídeo Hailuo 2.3 - Plataforma de Criação de Vídeo IA MiniMax',
        pageDescription:
            'Experimente o gerador de vídeo Hailuo 2.3 com conquistas revolucionárias em movimentos corporais complexos, estilização diversa, micro-expressões faciais e resposta a comandos de movimento de objetos.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, gerador de vídeo IA, vídeo de e-commerce, vitrine de produtos, vídeo dinâmico, vídeo IA grátis, WeryAI',

        generatorTitle: 'Gerador de Vídeo Hailuo 2.3',
        generatorDescription:
            'O WeryAI agora integra profundamente o modelo Hailuo 2.3, alcançando avanços importantes em <span class="text-text-active">movimentos corporais complexos, estilização diversa, micro-expressões faciais</span> e <span class="text-text-active">resposta a comandos de movimento de objetos</span>.',

        tabImageToVideo: 'Imagem para Vídeo',
        tabTextToVideo: 'Texto para Vídeo',

        coreFeaturesTitle: 'Recursos Principais do Hailuo 2.3',
        dynamicControlTitle:
            'Controle Dinâmico Mais Preciso e Visuais Realistas',
        dynamicControlDescription:
            'O desempenho físico do modelo e as capacidades de seguir instruções são significativamente aprimoradas.',
        styleSupportTitle: 'Suporte de Estilização Diversa Mais Forte',
        styleSupportDescription:
            'Melhor suporte para estilos artísticos especiais como anime, ilustração, pintura a tinta e CG de jogos.',
        microExpressionTitle:
            'Interpretação de Micro-expressões Faciais Mais Delicada',
        microExpressionDescription:
            'No Hailuo 2.3, as performances faciais de pessoas reais e mudanças de micro-expressões são mais naturais e delicadas.',
        objectMotionTitle:
            'Resposta Superior a Comandos de Movimento de Objetos',
        objectMotionDescription:
            'Otimizado especificamente para cenários de publicidade de e-commerce.',

        howToUseTitle: 'Como Usar',
        step1Title: 'Selecionar Modelo Hailuo 2.3',
        step1Description:
            'Vá para a página <span class="highlight-text">"Geração de Vídeo IA"</span>, depois clique em "Hailuo 2.3" no menu suspenso de modelos.',
        step2Title: 'Insira Seu Conteúdo Criativo',
        step2Description:
            'Descreva o que você deseja gerar ou carregue imagens para conversão.',
        step3Title: 'Baixe Seu Vídeo',
        step3Description:
            'Clique em "Criar" para baixar ou compartilhar o vídeo otimizado gerado.',

        youtubeTitle: 'Vídeos do YouTube sobre o Modelo de Vídeo Hailuo 2.3',
        xPostsTitle:
            'Publicações X Populares sobre o Modelo de Vídeo Hailuo 2.3',

        exploreModelsTitle: 'Explorar Outros Modelos',
        hailuo02Title: 'Gerador de Vídeo IA Hailuo 02',
        sora2Title: 'Gerador de Vídeo IA OpenAI Sora-2',
        wanTitle: 'Gerador de Vídeo IA Wan',

        faqTitle: 'Perguntas Frequentes',

        ctaTitle: 'Pronto para Começar a Criar?',
        ctaDescription:
            'Experimente o Hailuo 2.3 agora e transforme sua criatividade em vídeos incríveis',
        ctaButton: 'Experimente Hailuo 2.3 no WeryAI',
        ctaDisclaimer: 'Nenhum cartão de crédito necessário',

        videoNotSupported: 'Seu navegador não suporta reprodução de vídeo',
        videoLoadError: 'Falha ao carregar o vídeo',
        videoReload: 'Recarregar',
    },
    it: {
        pageTitle:
            'Generatore Video Hailuo 2.3 - Piattaforma di Creazione Video IA MiniMax',
        pageDescription:
            'Sperimenta il generatore video Hailuo 2.3 con conquiste rivoluzionarie nei movimenti corporei complessi, stilizzazione diversificata, micro-espressioni facciali e risposta ai comandi di movimento degli oggetti.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, generatore video IA, video e-commerce, vetrina prodotti, video dinamico, video IA gratuito, WeryAI',

        generatorTitle: 'Generatore Video Hailuo 2.3',
        generatorDescription:
            'WeryAI integra ora in profondità il modello Hailuo 2.3, ottenendo progressi chiave nei <span class="text-text-active">movimenti corporei complessi, stilizzazione diversificata, micro-espressioni facciali</span> e <span class="text-text-active">risposta ai comandi di movimento degli oggetti</span>.',

        tabImageToVideo: 'Immagine a Video',
        tabTextToVideo: 'Testo a Video',

        coreFeaturesTitle: 'Funzionalità Principali di Hailuo 2.3',
        dynamicControlTitle:
            'Controllo Dinamico Più Preciso e Visual Realistici',
        dynamicControlDescription:
            'Le prestazioni fisiche del modello e le capacità di seguire le istruzioni sono significativamente migliorate.',
        styleSupportTitle: 'Supporto di Stilizzazione Diversificata Più Forte',
        styleSupportDescription:
            'Migliore supporto per stili artistici speciali come anime, illustrazione, pittura a inchiostro e CG di videogiochi.',
        microExpressionTitle:
            'Interpretazione di Micro-espressioni Facciali Più Delicata',
        microExpressionDescription:
            'In Hailuo 2.3, le performance facciali di persone reali e i cambiamenti di micro-espressioni sono più naturali e delicati.',
        objectMotionTitle:
            'Risposta Superiore ai Comandi di Movimento degli Oggetti',
        objectMotionDescription:
            'Ottimizzato specificamente per scenari pubblicitari di e-commerce.',

        howToUseTitle: 'Come Usare',
        step1Title: 'Seleziona Modello Hailuo 2.3',
        step1Description:
            'Vai alla pagina <span class="highlight-text">"Generazione Video IA"</span>, quindi fai clic su "Hailuo 2.3" nel menu a discesa dei modelli.',
        step2Title: 'Inserisci il Tuo Contenuto Creativo',
        step2Description:
            'Descrivi cosa vuoi generare o carica immagini per la conversione.',
        step3Title: 'Scarica il Tuo Video',
        step3Description:
            'Fai clic su "Crea" per scaricare o condividere il video ottimizzato generato.',

        youtubeTitle: 'Video YouTube sul Modello Video Hailuo 2.3',
        xPostsTitle: 'Post X Popolari sul Modello Video Hailuo 2.3',

        exploreModelsTitle: 'Esplora Altri Modelli',
        hailuo02Title: 'Generatore Video IA Hailuo 02',
        sora2Title: 'Generatore Video IA OpenAI Sora-2',
        wanTitle: 'Generatore Video IA Wan',

        faqTitle: 'Domande Frequenti',

        ctaTitle: 'Pronto per Iniziare a Creare?',
        ctaDescription:
            'Sperimenta Hailuo 2.3 ora e trasforma la tua creatività in video straordinari',
        ctaButton: 'Prova Hailuo 2.3 su WeryAI',
        ctaDisclaimer: 'Nessuna carta di credito richiesta',

        videoNotSupported: 'Il tuo browser non supporta la riproduzione video',
        videoLoadError: 'Impossibile caricare il video',
        videoReload: 'Ricarica',
    },
    ar: {
        pageTitle:
            'مولد فيديو Hailuo 2.3 - منصة إنشاء فيديو بالذكاء الاصطناعي MiniMax',
        pageDescription:
            'جرب مولد فيديو Hailuo 2.3 مع إنجازات ثورية في حركات الجسم المعقدة والتصميم المتنوع وتعبيرات الوجه الدقيقة واستجابة أوامر حركة الأشياء.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, مولد فيديو بالذكاء الاصطناعي, فيديو التجارة الإلكترونية, عرض المنتجات, فيديو ديناميكي, فيديو ذكاء اصطناعي مجاني, WeryAI',

        generatorTitle: 'مولد فيديو Hailuo 2.3',
        generatorDescription:
            'يقوم WeryAI الآن بدمج نموذج Hailuo 2.3 بعمق، ',

        tabImageToVideo: 'صورة إلى فيديو',
        tabTextToVideo: 'نص إلى فيديو',

        coreFeaturesTitle: 'الميزات الأساسية لـ Hailuo 2.3',
        dynamicControlTitle: 'تحكم ديناميكي أكثر دقة ومرئيات واقعية',
        dynamicControlDescription:
            'تم تحسين الأداء الفيزيائي للنموذج وقدرات اتباع التعليمات بشكل كبير.',
        styleSupportTitle: 'دعم تصميم متنوع أقوى',
        styleSupportDescription:
            'دعم أفضل للأنماط الفنية الخاصة مثل الأنيمي والتوضيح والرسم بالحبر وCG ألعاب الفيديو.',
        microExpressionTitle: 'تفسير أكثر دقة لتعبيرات الوجه الدقيقة',
        microExpressionDescription:
            'في Hailuo 2.3، تكون عروض الوجه الحقيقية وتغيرات التعبيرات الدقيقة أكثر طبيعية ودقة.',
        objectMotionTitle: 'استجابة متفوقة لأوامر حركة الأشياء',
        objectMotionDescription:
            'محسّن خصيصًا لسيناريوهات إعلانات التجارة الإلكترونية.',

        howToUseTitle: 'كيفية الاستخدام',
        step1Title: 'حدد نموذج Hailuo 2.3',
        step1Description:
            'انتقل إلى صفحة <span class="highlight-text">"توليد فيديو بالذكاء الاصطناعي"</span>، ثم انقر على "Hailuo 2.3" في القائمة المنسدلة للنماذج.',
        step2Title: 'أدخل محتواك الإبداعي',
        step2Description: 'صف ما تريد توليده أو قم بتحميل الصور للتحويل.',
        step3Title: 'قم بتنزيل الفيديو الخاص بك',
        step3Description:
            'انقر على "إنشاء" لتنزيل أو مشاركة الفيديو المحسّن المولد.',

        youtubeTitle: 'فيديوهات YouTube حول نموذج الفيديو Hailuo 2.3',
        xPostsTitle: 'منشورات X الشائعة حول نموذج الفيديو Hailuo 2.3',

        exploreModelsTitle: 'استكشف نماذج أخرى',
        hailuo02Title: 'مولد فيديو بالذكاء الاصطناعي Hailuo 02',
        sora2Title: 'مولد فيديو بالذكاء الاصطناعي OpenAI Sora-2',
        wanTitle: 'مولد فيديو بالذكاء الاصطناعي Wan',

        faqTitle: 'الأسئلة الشائعة',

        ctaTitle: 'هل أنت مستعد للبدء في الإنشاء؟',
        ctaDescription:
            'جرب Hailuo 2.3 الآن وحوّل إبداعك إلى مقاطع فيديو مذهلة',
        ctaButton: 'جرب Hailuo 2.3 على WeryAI',
        ctaDisclaimer: 'لا حاجة لبطاقة ائتمان',

        videoNotSupported: 'متصفحك لا يدعم تشغيل الفيديو',
        videoLoadError: 'فشل تحميل الفيديو',
        videoReload: 'إعادة التحميل',
        },
    th: { // Thai (copied from English)
        // Page title and description
        pageTitle:
            'Hailuo 2.3 Video Generator - MiniMax AI Video Creation Platform',
        pageDescription:
            'Experience Hailuo 2.3 video generator with breakthrough achievements in complex body movements, diverse stylization, facial micro-expressions, and object motion command response. Optimized for e-commerce advertising scenarios. Try the next-generation AI video creation tool for free.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI video generator, e-commerce video, product showcase, dynamic video, free AI video, WeryAI',

        // Generator section
        generatorTitle: 'Hailuo 2.3 Video Generator',
        generatorDescription:
            'ขณะนี้ WeryAI ได้ผสานรวมโมเดล Hailuo 2.3 อย่างลึกซึ้งแล้ว ขณะนี้ WeryAI ได้ผสานรวมโมเดล Hailuo 2.3 อย่างลึกซึ้งแล้ว achieving key breakthroughs in <span class="text-text-active">complex body movements, diverse stylization, facial micro-expressions</span>, and <span class="text-text-active">object motion command response</span>. It excels at solving dynamic product display challenges in commercial scenarios such as e-commerce advertising, significantly improving video content quality and production efficiency. <span class="text-text-active">Try it free now</span> and experience the powerful charm of next-generation AI video creation!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo 2.3 Core Features',

        // More precise dynamic control and realistic visuals
        dynamicControlTitle:
            'More Precise Dynamic Control and Realistic Visuals',
        dynamicControlDescription:
            "The model's physical performance and instruction-following capabilities are significantly enhanced, generating more complex, smooth, and natural character body movements. Under different large dynamic camera movements, lighting, brightness transitions, and color tones can achieve near-real visual effects with higher stability and accuracy.",

        // Stronger diverse stylization support
        styleSupportTitle: 'Stronger Diverse Stylization Support',
        styleSupportDescription:
            'Better support for special art styles such as anime, illustration, ink painting, and game CG. Whether using general models or specific styles, output results are more stable and vivid, fully unleashing your artistic creative potential.',

        // More delicate facial micro-expression performance
        microExpressionTitle:
            'More Delicate Facial Micro-Expression Performance',
        microExpressionDescription:
            'In Hailuo 2.3, real-person facial performances and micro-expression changes are more natural and delicate. By capturing subtle expression changes through AI, it creates more infectious and story-driven character performances, making digital characters come to life.',

        // Superior object motion command response
        objectMotionTitle: 'Superior Object Motion Command Response',
        objectMotionDescription:
            'Optimized specifically for e-commerce advertising scenarios, with excellent response to product motion commands. It efficiently solves challenges in product movement and display, effectively improving the "draw rate" success and professionalism of e-commerce video advertising.',

        // How to use section
        howToUseTitle: 'วิธีใช้งาน',
        step1Title: 'Select Hailuo 2.3 Model',
        step1Description:
            'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo 2.3" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description:
            'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description:
            'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 2.3 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 2.3 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models',
        hailuo02Title: 'Hailuo 02 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        wanTitle: 'Wan AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',







        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription:
            'Experience Hailuo 2.3 now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo 2.3 on WeryAI',

        ctaDisclaimer: 'No credit card required',


        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
        },
    da: { // Danish (copied from English)
        // Page title and description
        pageTitle:
            'Hailuo 2.3 Video Generator - MiniMax AI Video Creation Platform',
        pageDescription:
            'Experience Hailuo 2.3 video generator with breakthrough achievements in complex body movements, diverse stylization, facial micro-expressions, and object motion command response. Optimized for e-commerce advertising scenarios. Try the next-generation AI video creation tool for free.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI video generator, e-commerce video, product showcase, dynamic video, free AI video, WeryAI',

        // Generator section
        generatorTitle: 'Hailuo 2.3 Video Generator',
        generatorDescription:
            'WeryAI har nu integreret modellen Hailuo 2.3 i dybden, achieving key breakthroughs in <span class="text-text-active">complex body movements, diverse stylization, facial micro-expressions</span>, and <span class="text-text-active">object motion command response</span>. It excels at solving dynamic product display challenges in commercial scenarios such as e-commerce advertising, significantly improving video content quality and production efficiency. <span class="text-text-active">Try it free now</span> and experience the powerful charm of next-generation AI video creation!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo 2.3 Core Features',

        // More precise dynamic control and realistic visuals
        dynamicControlTitle:
            'More Precise Dynamic Control and Realistic Visuals',
        dynamicControlDescription:
            "The model's physical performance and instruction-following capabilities are significantly enhanced, generating more complex, smooth, and natural character body movements. Under different large dynamic camera movements, lighting, brightness transitions, and color tones can achieve near-real visual effects with higher stability and accuracy.",

        // Stronger diverse stylization support
        styleSupportTitle: 'Stronger Diverse Stylization Support',
        styleSupportDescription:
            'Better support for special art styles such as anime, illustration, ink painting, and game CG. Whether using general models or specific styles, output results are more stable and vivid, fully unleashing your artistic creative potential.',

        // More delicate facial micro-expression performance
        microExpressionTitle:
            'More Delicate Facial Micro-Expression Performance',
        microExpressionDescription:
            'In Hailuo 2.3, real-person facial performances and micro-expression changes are more natural and delicate. By capturing subtle expression changes through AI, it creates more infectious and story-driven character performances, making digital characters come to life.',

        // Superior object motion command response
        objectMotionTitle: 'Superior Object Motion Command Response',
        objectMotionDescription:
            'Optimized specifically for e-commerce advertising scenarios, with excellent response to product motion commands. It efficiently solves challenges in product movement and display, effectively improving the "draw rate" success and professionalism of e-commerce video advertising.',

        // How to use section
        howToUseTitle: 'Sådan bruges det',
        step1Title: 'Select Hailuo 2.3 Model',
        step1Description:
            'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo 2.3" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description:
            'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description:
            'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 2.3 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 2.3 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models',
        hailuo02Title: 'Hailuo 02 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        wanTitle: 'Wan AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',







        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription:
            'Experience Hailuo 2.3 now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo 2.3 on WeryAI',

        ctaDisclaimer: 'No credit card required',


        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
        },
    no: { // Norwegian (copied from English)
        // Page title and description
        pageTitle:
            'Hailuo 2.3 Video Generator - MiniMax AI Video Creation Platform',
        pageDescription:
            'Experience Hailuo 2.3 video generator with breakthrough achievements in complex body movements, diverse stylization, facial micro-expressions, and object motion command response. Optimized for e-commerce advertising scenarios. Try the next-generation AI video creation tool for free.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI video generator, e-commerce video, product showcase, dynamic video, free AI video, WeryAI',

        // Generator section
        generatorTitle: 'Hailuo 2.3 Video Generator',
        generatorDescription:
            'WeryAI har nå integrert modellen Hailuo 2.3 i dybden, achieving key breakthroughs in <span class="text-text-active">complex body movements, diverse stylization, facial micro-expressions</span>, and <span class="text-text-active">object motion command response</span>. It excels at solving dynamic product display challenges in commercial scenarios such as e-commerce advertising, significantly improving video content quality and production efficiency. <span class="text-text-active">Try it free now</span> and experience the powerful charm of next-generation AI video creation!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo 2.3 Core Features',

        // More precise dynamic control and realistic visuals
        dynamicControlTitle:
            'More Precise Dynamic Control and Realistic Visuals',
        dynamicControlDescription:
            "The model's physical performance and instruction-following capabilities are significantly enhanced, generating more complex, smooth, and natural character body movements. Under different large dynamic camera movements, lighting, brightness transitions, and color tones can achieve near-real visual effects with higher stability and accuracy.",

        // Stronger diverse stylization support
        styleSupportTitle: 'Stronger Diverse Stylization Support',
        styleSupportDescription:
            'Better support for special art styles such as anime, illustration, ink painting, and game CG. Whether using general models or specific styles, output results are more stable and vivid, fully unleashing your artistic creative potential.',

        // More delicate facial micro-expression performance
        microExpressionTitle:
            'More Delicate Facial Micro-Expression Performance',
        microExpressionDescription:
            'In Hailuo 2.3, real-person facial performances and micro-expression changes are more natural and delicate. By capturing subtle expression changes through AI, it creates more infectious and story-driven character performances, making digital characters come to life.',

        // Superior object motion command response
        objectMotionTitle: 'Superior Object Motion Command Response',
        objectMotionDescription:
            'Optimized specifically for e-commerce advertising scenarios, with excellent response to product motion commands. It efficiently solves challenges in product movement and display, effectively improving the "draw rate" success and professionalism of e-commerce video advertising.',

        // How to use section
        howToUseTitle: 'Slik bruker du',
        step1Title: 'Select Hailuo 2.3 Model',
        step1Description:
            'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo 2.3" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description:
            'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description:
            'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 2.3 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 2.3 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models',
        hailuo02Title: 'Hailuo 02 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        wanTitle: 'Wan AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',







        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription:
            'Experience Hailuo 2.3 now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo 2.3 on WeryAI',

        ctaDisclaimer: 'No credit card required',


        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
        },
    nl: { // Dutch (copied from English)
        // Page title and description
        pageTitle:
            'Hailuo 2.3 Video Generator - MiniMax AI Video Creation Platform',
        pageDescription:
            'Experience Hailuo 2.3 video generator with breakthrough achievements in complex body movements, diverse stylization, facial micro-expressions, and object motion command response. Optimized for e-commerce advertising scenarios. Try the next-generation AI video creation tool for free.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI video generator, e-commerce video, product showcase, dynamic video, free AI video, WeryAI',

        // Generator section
        generatorTitle: 'Hailuo 2.3 Video Generator',
        generatorDescription:
            'WeryAI heeft het model Hailuo 2.3 nu diep geïntegreerd, achieving key breakthroughs in <span class="text-text-active">complex body movements, diverse stylization, facial micro-expressions</span>, and <span class="text-text-active">object motion command response</span>. It excels at solving dynamic product display challenges in commercial scenarios such as e-commerce advertising, significantly improving video content quality and production efficiency. <span class="text-text-active">Try it free now</span> and experience the powerful charm of next-generation AI video creation!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo 2.3 Core Features',

        // More precise dynamic control and realistic visuals
        dynamicControlTitle:
            'More Precise Dynamic Control and Realistic Visuals',
        dynamicControlDescription:
            "The model's physical performance and instruction-following capabilities are significantly enhanced, generating more complex, smooth, and natural character body movements. Under different large dynamic camera movements, lighting, brightness transitions, and color tones can achieve near-real visual effects with higher stability and accuracy.",

        // Stronger diverse stylization support
        styleSupportTitle: 'Stronger Diverse Stylization Support',
        styleSupportDescription:
            'Better support for special art styles such as anime, illustration, ink painting, and game CG. Whether using general models or specific styles, output results are more stable and vivid, fully unleashing your artistic creative potential.',

        // More delicate facial micro-expression performance
        microExpressionTitle:
            'More Delicate Facial Micro-Expression Performance',
        microExpressionDescription:
            'In Hailuo 2.3, real-person facial performances and micro-expression changes are more natural and delicate. By capturing subtle expression changes through AI, it creates more infectious and story-driven character performances, making digital characters come to life.',

        // Superior object motion command response
        objectMotionTitle: 'Superior Object Motion Command Response',
        objectMotionDescription:
            'Optimized specifically for e-commerce advertising scenarios, with excellent response to product motion commands. It efficiently solves challenges in product movement and display, effectively improving the "draw rate" success and professionalism of e-commerce video advertising.',

        // How to use section
        howToUseTitle: 'Zo gebruik je het',
        step1Title: 'Select Hailuo 2.3 Model',
        step1Description:
            'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo 2.3" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description:
            'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description:
            'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 2.3 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 2.3 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models',
        hailuo02Title: 'Hailuo 02 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        wanTitle: 'Wan AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',







        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription:
            'Experience Hailuo 2.3 now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo 2.3 on WeryAI',

        ctaDisclaimer: 'No credit card required',


        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
        },
    id: { // Indonesian (copied from English)
        // Page title and description
        pageTitle:
            'Hailuo 2.3 Video Generator - MiniMax AI Video Creation Platform',
        pageDescription:
            'Experience Hailuo 2.3 video generator with breakthrough achievements in complex body movements, diverse stylization, facial micro-expressions, and object motion command response. Optimized for e-commerce advertising scenarios. Try the next-generation AI video creation tool for free.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI video generator, e-commerce video, product showcase, dynamic video, free AI video, WeryAI',

        // Generator section
        generatorTitle: 'Hailuo 2.3 Video Generator',
        generatorDescription:
            'WeryAI kini telah mengintegrasikan model Hailuo 2.3 secara mendalam, achieving key breakthroughs in <span class="text-text-active">complex body movements, diverse stylization, facial micro-expressions</span>, and <span class="text-text-active">object motion command response</span>. It excels at solving dynamic product display challenges in commercial scenarios such as e-commerce advertising, significantly improving video content quality and production efficiency. <span class="text-text-active">Try it free now</span> and experience the powerful charm of next-generation AI video creation!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo 2.3 Core Features',

        // More precise dynamic control and realistic visuals
        dynamicControlTitle:
            'More Precise Dynamic Control and Realistic Visuals',
        dynamicControlDescription:
            "The model's physical performance and instruction-following capabilities are significantly enhanced, generating more complex, smooth, and natural character body movements. Under different large dynamic camera movements, lighting, brightness transitions, and color tones can achieve near-real visual effects with higher stability and accuracy.",

        // Stronger diverse stylization support
        styleSupportTitle: 'Stronger Diverse Stylization Support',
        styleSupportDescription:
            'Better support for special art styles such as anime, illustration, ink painting, and game CG. Whether using general models or specific styles, output results are more stable and vivid, fully unleashing your artistic creative potential.',

        // More delicate facial micro-expression performance
        microExpressionTitle:
            'More Delicate Facial Micro-Expression Performance',
        microExpressionDescription:
            'In Hailuo 2.3, real-person facial performances and micro-expression changes are more natural and delicate. By capturing subtle expression changes through AI, it creates more infectious and story-driven character performances, making digital characters come to life.',

        // Superior object motion command response
        objectMotionTitle: 'Superior Object Motion Command Response',
        objectMotionDescription:
            'Optimized specifically for e-commerce advertising scenarios, with excellent response to product motion commands. It efficiently solves challenges in product movement and display, effectively improving the "draw rate" success and professionalism of e-commerce video advertising.',

        // How to use section
        howToUseTitle: 'Cara Menggunakan',
        step1Title: 'Select Hailuo 2.3 Model',
        step1Description:
            'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo 2.3" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description:
            'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description:
            'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 2.3 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 2.3 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models',
        hailuo02Title: 'Hailuo 02 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        wanTitle: 'Wan AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',







        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription:
            'Experience Hailuo 2.3 now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo 2.3 on WeryAI',

        ctaDisclaimer: 'No credit card required',


        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
        },
    tr: { // Turkish (copied from English)
        // Page title and description
        pageTitle:
            'Hailuo 2.3 Video Generator - MiniMax AI Video Creation Platform',
        pageDescription:
            'Experience Hailuo 2.3 video generator with breakthrough achievements in complex body movements, diverse stylization, facial micro-expressions, and object motion command response. Optimized for e-commerce advertising scenarios. Try the next-generation AI video creation tool for free.',
        pageKeywords:
            'Hailuo 2.3, MiniMax, AI video generator, e-commerce video, product showcase, dynamic video, free AI video, WeryAI',

        // Generator section
        generatorTitle: 'Hailuo 2.3 Video Generator',
        generatorDescription:
            'WeryAI artık Hailuo 2.3 modelini derinlemesine entegre ediyor, achieving key breakthroughs in <span class="text-text-active">complex body movements, diverse stylization, facial micro-expressions</span>, and <span class="text-text-active">object motion command response</span>. It excels at solving dynamic product display challenges in commercial scenarios such as e-commerce advertising, significantly improving video content quality and production efficiency. <span class="text-text-active">Try it free now</span> and experience the powerful charm of next-generation AI video creation!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Hailuo 2.3 Core Features',

        // More precise dynamic control and realistic visuals
        dynamicControlTitle:
            'More Precise Dynamic Control and Realistic Visuals',
        dynamicControlDescription:
            "The model's physical performance and instruction-following capabilities are significantly enhanced, generating more complex, smooth, and natural character body movements. Under different large dynamic camera movements, lighting, brightness transitions, and color tones can achieve near-real visual effects with higher stability and accuracy.",

        // Stronger diverse stylization support
        styleSupportTitle: 'Stronger Diverse Stylization Support',
        styleSupportDescription:
            'Better support for special art styles such as anime, illustration, ink painting, and game CG. Whether using general models or specific styles, output results are more stable and vivid, fully unleashing your artistic creative potential.',

        // More delicate facial micro-expression performance
        microExpressionTitle:
            'More Delicate Facial Micro-Expression Performance',
        microExpressionDescription:
            'In Hailuo 2.3, real-person facial performances and micro-expression changes are more natural and delicate. By capturing subtle expression changes through AI, it creates more infectious and story-driven character performances, making digital characters come to life.',

        // Superior object motion command response
        objectMotionTitle: 'Superior Object Motion Command Response',
        objectMotionDescription:
            'Optimized specifically for e-commerce advertising scenarios, with excellent response to product motion commands. It efficiently solves challenges in product movement and display, effectively improving the "draw rate" success and professionalism of e-commerce video advertising.',

        // How to use section
        howToUseTitle: 'Nasıl Kullanılır',
        step1Title: 'Select Hailuo 2.3 Model',
        step1Description:
            'Go to the <span class="highlight-text">"AI Video Generation"</span> page, then click "Hailuo 2.3" in the model dropdown menu.',
        step2Title: 'Input Your Creative Content',
        step2Description:
            'Describe what you want to generate, or upload images for conversion, and choose your preferred styles and effects.',
        step3Title: 'Download Your Video',
        step3Description:
            'Click "Create" to download or share the generated optimized video.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Hailuo 2.3 Video Model',

        // X Posts section
        xPostsTitle: 'Popular X Posts About Hailuo 2.3 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Video Models',
        hailuo02Title: 'Hailuo 02 AI Video Generator',
        sora2Title: 'OpenAI Sora-2 AI Video Generator',
        wanTitle: 'Wan AI Video Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',







        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription:
            'Experience Hailuo 2.3 now and transform your creativity into amazing videos',
        ctaButton: 'Try Hailuo 2.3 on WeryAI',

        ctaDisclaimer: 'No credit card required',


        // Video playback related
        videoNotSupported: 'Your browser does not support video playback',
        videoLoadError: 'Video failed to load',
        videoReload: 'Reload',
    },
}
